import { render } from "./BodyComponent.vue?vue&type=template&id=43043eda&scoped=true"
import script from "./BodyComponent.vue?vue&type=script&lang=js"
export * from "./BodyComponent.vue?vue&type=script&lang=js"

import "./BodyComponent.vue?vue&type=style&index=0&id=43043eda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43043eda"]])

export default __exports__